import { render, staticRenderFns } from "./extrageneticDirectories.vue?vue&type=template&id=91dbead8&scoped=true"
import script from "./extrageneticDirectories.vue?vue&type=script&lang=js"
export * from "./extrageneticDirectories.vue?vue&type=script&lang=js"
import style0 from "./extrageneticDirectories.vue?vue&type=style&index=0&id=91dbead8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91dbead8",
  null
  
)

export default component.exports